// Column list matching the authenticated table grants on "People". The
// backend revokes table-level SELECT and re-grants every column EXCEPT
// customFieldValues, for all plans — custom-field data is only readable
// through the get_person_custom_fields RPC. PostgREST/Postgres expands `*`
// against table privileges, so `*` anywhere on People (direct selects or
// embeds like `People(*)`) fails with 42501. Use this constant instead.
export const PEOPLE_SELECT =
    'id, createdAt, updatedAt, organizationID, firstName, lastName, gender, dateOfBirth, email, invitedByID, isArchived, breezePersonID, addressID, isAdmin, phone, fullName, avatarUpdatedAt, breezeAvatarURL, barcode, search_vector, familyID, familyRole, avatarStorageKey, invitedByNote';
